import PeriodicTable from "./components/PeriodicTable"
import "./styles/index.css"

const App = () => {
  return (
    <div className="container">
      <div className="title">The Modern Periodic Table</div>
      <PeriodicTable />
    </div>
  );
}

export default App;
